import React, { useMemo, useEffect } from "react";
import DataTable from "../_Components/DataTable";
import SplitNumber from "../_Components/SplitNumber";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import _ from "lodash";
import { Button } from "react-bootstrap";
// import { ViewModal } from "./ViewModal";
function DataGrid({ data, setShowModalSupplierTransaction, setSelectedSupplierTransaction }) {
  const columns = useMemo(
    () => [
      {
        accessor: "id",
        Header: "#",
        minWidth: 50,
      },
      {
        accessor: "basketId",
        Header: "شماره سفارش",
        minWidth: 50,
      },

      {
        accessor: "supplierCompanyName",
        Header: "تامین کننده",
        minWidth: "100px",
      },
      {
        Header: "مبلغ",
        minWidth: 100,
        accessor: "amount",
        align: "center",
        Cell: ({ row }) =>
          row.original.balanceType === 1 ? (
            <div className="text-center" style={{ color: "#099145" }}>
              <ArrowUpwardIcon />
              <SplitNumber number={row.original.amount} />
            </div>
          ) : (
            <div className="text-center text-danger">
              <ArrowDownwardIcon />
              <SplitNumber number={row.original.amount} />
            </div>
          ),
      },
      // {
      //   accessor: "paymentDate",
      //   Header: "تاریخ انجام",
      //   minWidth: '100px',
      //   Cell: ({ row }) => (
      //     <div className="text-center success">
      //       {row.original.paymentDate} - {row.original.paymentTime}
      //     </div>
      //   )
      // },
      // {
      //   accessor: "paymentTime",
      //   Header: "ساعت پرداخت",
      //   minWidth: '100px',
      // },
      // {
      //   accessor: "trackingCode",
      //   Header: "کد رهگیری",
      //   minWidth: '100px',
      // },

      {
        Header: "تاریخ تراکنش",
        minWidth: 100,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {_.toString(row.original.completionDate)} - {_.toString(row.original.completionTime)}
          </div>
        ),
      },
      {
        accessor: "description",
        Header: "توضیحات",
        minWidth: "100px",
      },
      // {
      //   accessor: "destinationAccountId",
      //   Header: "حساب تامین کننده",
      //   minWidth: '100px',
      // },
      // {
      //   accessor: "sourceAccountId",
      //   Header: "حساب سامانه",
      //   minWidth: '100px',
      // },
      {
        Header: "عملیات",
        accessor: "",
        minWidth: 150,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {/* مشاهده  */}
            <Button
              className="btn btn-light-info btn-sm mr-2 btn-icon"
              title="مشاهده اطلاعات"
              onClick={() => {
                setShowModalSupplierTransaction(true);
                setSelectedSupplierTransaction(row.original);
              }}
            >
              <i className="far fa-eye text-small"></i>
            </Button>
          </div>
        ),
      },
    ],
    [],
  );

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
